import { Component, inject, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IHemoTechPublicRecord } from 'app/models/licenses/hemo-tech/hemo-tech-public-record';
import { HemoTechLicenseService } from 'app/services/license/hemo-tech/hemo-tech-license.service';

@Component({
  selector: 'app-hemo-tech-public-list',
  templateUrl: './hemo-tech-public-list.component.html',
  styleUrls: ['./hemo-tech-public-list.component.scss']
})
export class HemoTechPublicListComponent {
  public licensees: IHemoTechPublicRecord[] = [];

  public displayedColumns: string[] = ['firstName', 'lastName', 'certification', 'certificationDate', 'expirationDate'];
  public source = new MatTableDataSource<IHemoTechPublicRecord>(this.licensees);
  @ViewChild('licenseePaginator', {static: false}) licenseePaginator: MatPaginator;
  @ViewChild('licenseeSort', {static: false}) licenseeSort: MatSort;

  public sharedService: SharedService = inject(SharedService);
  public hemoTechService: HemoTechLicenseService = inject(HemoTechLicenseService);

  ngOnInit(): void {
    this.getPublicRecords();
  }

  getPublicRecords(): void {
    this.hemoTechService.getPublicRecords().subscribe({
      next: response => this.licensees = response,
      error: e => {
        this.sharedService.toastr.error("Error getting public records");
        console.log('Error getting public records', e);
      },
      complete: () => this.updateTable()
    });
  }

  updateTable(): void {
    setTimeout(() => {
      this.source.data = this.licensees;
      this.source.paginator = this.licenseePaginator;
      this.source.sort = this.licenseeSort;
    }, 500);
  }
}
